import css from '../../css/toolbox.module.css';
import { toolBoxManagerTemplate } from './toolBoxManagerTemplate';

export class ToolBox3DManager extends toolBoxManagerTemplate {
	constructor( modules, managers ) {	
		super( modules, managers );
		this.managers.ToolBox3DManager = this;
	}

	async init() {
		
		//add css
		this._addStyle( 'toolboxStyle', css );
		document.querySelector( '#toolbox' ).innerHTML = '';
		this.modules.toolbox.init( { containerId: 'toolbox', buttonList: this.#getButtonList() } );

		this._addVLineAfterButton( 'groupEdition' );
	}
	
	#getButtonList() {
		return this.#getUtilityButtonList();//.
		//concat( this.#get3Dto2DButton() );
	}

	#getUtilityButtonList() {
		return [
			{
				title: 'Group Edition',
				containerId: 'utility2DContainer',
				name: 'groupEdition',
				icon: 'border_all',
				label: '',
				callback: async e => {
					//disable button while trigering event. Store targets since they may change during event
					const targets = { t: e.target, c: e.currentTarget };
					this.disable( targets.t, targets.c );
					await this.trigger( 'onGroupSelection' );
					this.enable( targets.t, targets.c );
				}
			},
			{
				title: 'Zone Edition',
				containerId: 'utility2DContainer',
				name: 'zoneEdition',
				icon: 'app_registration',
				label: '',
				callback: async e => {
					//disable button while trigering event. Store targets since they may change during event
					const targets = { t: e.target, c: e.currentTarget };
					this.disable( targets.t, targets.c );
					await this.trigger( 'onZoneSelection' );
					this.enable( targets.t, targets.c );
				}
			}
		];
	}

	#get3Dto2DButton() {
		return [
			{
				title: 'Atras',
				containerId: 'back',
				name: 'back',
				icon: 'arrow_back',
				label: '',
				callback: async e => {
					//disable button while trigering event. Store targets since they may change during event
					const targets = { t: e.target, c: e.currentTarget };
					this.disable( targets.t, targets.c );
					await this.trigger( 'backTo2D' );
					this.enable( targets.t, targets.c );
				}
			}
		];
	}
}